import { BrainCircuit, SlidersHorizontal, FileSearch, Rocket } from "lucide-react";

// Canonical list of candidate feature pages — one source of truth for the
// Navbar mega-menu, each page's "Explore more features" grid, and footer links.
// `icon` holds the lucide component reference (no JSX here — just the identifier).
// `comingSoon` entries have no page yet: they render grayed with a "Coming soon"
// badge and are never clickable (no `to`).
export const FEATURE_LINKS = [
  { key: "mock-interview",   label: "Mock Interviews",  to: "/features/mock-interview",   desc: "Voice practice with instant AI scoring", icon: BrainCircuit,      accent: "#0025D8" },
  { key: "custom-interview", label: "Custom Interview", to: "/features/custom-interview", desc: "Turn any JD or doc into an interview",    icon: SlidersHorizontal, accent: "#0F172A" },
  { key: "resume-analyzer",  label: "Resume Analyzer",  to: "/features/resume-analyzer",  desc: "ATS score, keyword gaps + AI rewrite",   icon: FileSearch,        accent: "#7C3AED" },
  // Was `label: "Auto Apply", to: null, comingSoon: true` until 2026-10-25 — i.e. the flagship
  // advertised itself as unavailable, under its retired name, on every surface this list feeds
  // (navbar mega-menu, mobile menu, landing grid, footer). It has been live for weeks.
  { key: "autopilot",        label: "Autopilot",        to: "/features/autopilot",         desc: "Applies to your matched jobs for you",   icon: Rocket,            accent: "#EA580C" },
];

// Sibling links for a given page key (everything except itself).
export const siblingLinks = (selfKey) => FEATURE_LINKS.filter((f) => f.key !== selfKey);
